import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTokenValidation } from '../hooks/useTokenValidation';
import LoginForm from '../components/auth/LoginForm';
import Alert from '../components/ui/Alert';

const LoginPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const [isValidatingToken, setIsValidatingToken] = useState(false);
    const { isValidating } = useTokenValidation();

    useEffect(() => {
        // Check if there's a token in the URL
        const token = searchParams.get('token');
        setIsValidatingToken(!!token);
    }, [searchParams]);

    // Show loading screen while validating token
    if (isValidatingToken || isValidating) {
        return (
            <div className="container">
                <div id="login-page">
                    <div className="header">
                        <h1>🔐 Validating Access</h1>
                        <p>Please wait while we verify your credentials...</p>
                    </div>
                    <div style={{
                        textAlign: 'center',
                        padding: '40px 20px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '20px'
                    }}>
                        <div className="loading-spinner" style={{
                            margin: '0 auto',
                            width: '50px',
                            height: '50px'
                        }}></div>
                        <p style={{
                            color: '#666',
                            fontSize: '16px',
                            margin: 0
                        }}>
                            Validating your access token...
                        </p>
                    </div>
                    <Alert />
                </div>
            </div>
        );
    }

    // Show login form if no token or validation failed
    return (
        <div className="container">
            <div id="login-page">
                <div className="header">
                    <h1>🔐 Login</h1>
                    <p>Enter your email to receive a login code</p>
                </div>
                <Alert />
                <LoginForm />
            </div>
        </div>
    );
};

export default LoginPage;